// Voice Models Configuration for Voice Agent Mode

// Orpheus Fast Voices (Groq - Orpheus Fast)
// Fast, emotion-aware, multilingual
export const ORPHEUS_FAST_VOICES = [
  {
    name: "Autumn",
    id: "autumn",
    provider: "orpheus-fast",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Warm (default)",
  },
  {
    name: "Diana",
    id: "diana",
    provider: "orpheus-fast",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Clear",
  },
  {
    name: "Hannah",
    id: "hannah",
    provider: "orpheus-fast",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Friendly",
  },
  {
    name: "Austin",
    id: "austin",
    provider: "orpheus-fast",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Professional",
  },
  {
    name: "Daniel",
    id: "daniel",
    provider: "orpheus-fast",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Conversational",
  },
  {
    name: "Troy",
    id: "troy",
    provider: "orpheus-fast",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Energetic",
  },
];

// Orpheus Voices (Together AI - canopylabs/orpheus-3b-0.1-ft)
// High quality, emotion-aware, multilingual
export const ORPHEUS_VOICES = [
  {
    name: "Tara",
    id: "tara",
    provider: "orpheus",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Leah",
    id: "leah",
    provider: "orpheus",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Jess",
    id: "jess",
    provider: "orpheus",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Leo",
    id: "leo",
    provider: "orpheus",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Standard",
  },
  {
    name: "Dan",
    id: "dan",
    provider: "orpheus",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Standard",
  },
  {
    name: "Mia",
    id: "mia",
    provider: "orpheus",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Zac",
    id: "zac",
    provider: "orpheus",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Standard",
  },
  {
    name: "Zoe",
    id: "zoe",
    provider: "orpheus",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Standard",
  },
];

// Kokoro Voices (Together AI - hexgrad/Kokoro-82M)
// Fast, lightweight, multilingual
export const KOKORO_VOICES = [
  // American Female
  {
    name: "Heart",
    id: "af_heart",
    provider: "kokoro",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Alloy",
    id: "af_alloy",
    provider: "kokoro",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Aoede",
    id: "af_aoede",
    provider: "kokoro",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Bella",
    id: "af_bella",
    provider: "kokoro",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Jessica",
    id: "af_jessica",
    provider: "kokoro",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Kore",
    id: "af_kore",
    provider: "kokoro",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Nicole",
    id: "af_nicole",
    provider: "kokoro",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Nova",
    id: "af_nova",
    provider: "kokoro",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "River",
    id: "af_river",
    provider: "kokoro",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Sarah",
    id: "af_sarah",
    provider: "kokoro",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Sky",
    id: "af_sky",
    provider: "kokoro",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Standard",
  },
  // American Male
  {
    name: "Adam",
    id: "am_adam",
    provider: "kokoro",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Standard",
  },
  {
    name: "Echo",
    id: "am_echo",
    provider: "kokoro",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Standard",
  },
  {
    name: "Eric",
    id: "am_eric",
    provider: "kokoro",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Standard",
  },
  {
    name: "Fenrir",
    id: "am_fenrir",
    provider: "kokoro",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Standard",
  },
  {
    name: "Liam",
    id: "am_liam",
    provider: "kokoro",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Standard",
  },
  {
    name: "Michael",
    id: "am_michael",
    provider: "kokoro",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Standard",
  },
  {
    name: "Onyx",
    id: "am_onyx",
    provider: "kokoro",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Standard",
  },
  {
    name: "Puck",
    id: "am_puck",
    provider: "kokoro",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Standard",
  },
  {
    name: "Santa",
    id: "am_santa",
    provider: "kokoro",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Standard",
  },
  // British Female
  {
    name: "Alice",
    id: "bf_alice",
    provider: "kokoro",
    language: "en",
    accent: "British",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Emma",
    id: "bf_emma",
    provider: "kokoro",
    language: "en",
    accent: "British",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Isabella",
    id: "bf_isabella",
    provider: "kokoro",
    language: "en",
    accent: "British",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Lily",
    id: "bf_lily",
    provider: "kokoro",
    language: "en",
    accent: "British",
    gender: "Female",
    speed: "Standard",
  },
  // British Male
  {
    name: "Daniel",
    id: "bm_daniel",
    provider: "kokoro",
    language: "en",
    accent: "British",
    gender: "Male",
    speed: "Standard",
  },
  {
    name: "Fable",
    id: "bm_fable",
    provider: "kokoro",
    language: "en",
    accent: "British",
    gender: "Male",
    speed: "Standard",
  },
  {
    name: "George",
    id: "bm_george",
    provider: "kokoro",
    language: "en",
    accent: "British",
    gender: "Male",
    speed: "Standard",
  },
  {
    name: "Lewis",
    id: "bm_lewis",
    provider: "kokoro",
    language: "en",
    accent: "British",
    gender: "Male",
    speed: "Standard",
  },
  // Japanese Female
  {
    name: "Alpha",
    id: "jf_alpha",
    provider: "kokoro",
    language: "ja",
    accent: "Japanese",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Gongitsune",
    id: "jf_gongitsune",
    provider: "kokoro",
    language: "ja",
    accent: "Japanese",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Nezumi",
    id: "jf_nezumi",
    provider: "kokoro",
    language: "ja",
    accent: "Japanese",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Tebukuro",
    id: "jf_tebukuro",
    provider: "kokoro",
    language: "ja",
    accent: "Japanese",
    gender: "Female",
    speed: "Standard",
  },
  // Japanese Male
  {
    name: "Kumo",
    id: "jm_kumo",
    provider: "kokoro",
    language: "ja",
    accent: "Japanese",
    gender: "Male",
    speed: "Standard",
  },
  // Chinese Female
  {
    name: "Xiaobei",
    id: "zf_xiaobei",
    provider: "kokoro",
    language: "zh",
    accent: "Mandarin",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Xiaoni",
    id: "zf_xiaoni",
    provider: "kokoro",
    language: "zh",
    accent: "Mandarin",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Xiaoxiao",
    id: "zf_xiaoxiao",
    provider: "kokoro",
    language: "zh",
    accent: "Mandarin",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Xiaoyi",
    id: "zf_xiaoyi",
    provider: "kokoro",
    language: "zh",
    accent: "Mandarin",
    gender: "Female",
    speed: "Standard",
  },
  // Chinese Male
  {
    name: "Yunjian",
    id: "zm_yunjian",
    provider: "kokoro",
    language: "zh",
    accent: "Mandarin",
    gender: "Male",
    speed: "Standard",
  },
  {
    name: "Yunxi",
    id: "zm_yunxi",
    provider: "kokoro",
    language: "zh",
    accent: "Mandarin",
    gender: "Male",
    speed: "Standard",
  },
  {
    name: "Yunxia",
    id: "zm_yunxia",
    provider: "kokoro",
    language: "zh",
    accent: "Mandarin",
    gender: "Male",
    speed: "Standard",
  },
  {
    name: "Yunyang",
    id: "zm_yunyang",
    provider: "kokoro",
    language: "zh",
    accent: "Mandarin",
    gender: "Male",
    speed: "Standard",
  },
  // Spanish Female
  {
    name: "Dora",
    id: "ef_dora",
    provider: "kokoro",
    language: "es",
    accent: "Spanish",
    gender: "Female",
    speed: "Standard",
  },
  // Spanish Male
  {
    name: "Alex",
    id: "em_alex",
    provider: "kokoro",
    language: "es",
    accent: "Spanish",
    gender: "Male",
    speed: "Standard",
  },
  {
    name: "Santa",
    id: "em_santa",
    provider: "kokoro",
    language: "es",
    accent: "Spanish",
    gender: "Male",
    speed: "Standard",
  },
  // French Female
  {
    name: "Siwis",
    id: "ff_siwis",
    provider: "kokoro",
    language: "fr",
    accent: "French",
    gender: "Female",
    speed: "Standard",
  },
  // Hindi Female
  {
    name: "Alpha",
    id: "hf_alpha",
    provider: "kokoro",
    language: "hi",
    accent: "Hindi",
    gender: "Female",
    speed: "Standard",
  },
  {
    name: "Beta",
    id: "hf_beta",
    provider: "kokoro",
    language: "hi",
    accent: "Hindi",
    gender: "Female",
    speed: "Standard",
  },
  // Hindi Male
  {
    name: "Omega",
    id: "hm_omega",
    provider: "kokoro",
    language: "hi",
    accent: "Hindi",
    gender: "Male",
    speed: "Standard",
  },
  {
    name: "Psi",
    id: "hm_psi",
    provider: "kokoro",
    language: "hi",
    accent: "Hindi",
    gender: "Male",
    speed: "Standard",
  },
  // Italian Female
  {
    name: "Sara",
    id: "if_sara",
    provider: "kokoro",
    language: "it",
    accent: "Italian",
    gender: "Female",
    speed: "Standard",
  },
  // Italian Male
  {
    name: "Nicola",
    id: "im_nicola",
    provider: "kokoro",
    language: "it",
    accent: "Italian",
    gender: "Male",
    speed: "Standard",
  },
  // Brazilian Portuguese Female
  {
    name: "Dora",
    id: "pf_dora",
    provider: "kokoro",
    language: "pt",
    accent: "Brazilian",
    gender: "Female",
    speed: "Standard",
  },
  // Brazilian Portuguese Male
  {
    name: "Alex",
    id: "pm_alex",
    provider: "kokoro",
    language: "pt",
    accent: "Brazilian",
    gender: "Male",
    speed: "Standard",
  },
  {
    name: "Santa",
    id: "pm_santa",
    provider: "kokoro",
    language: "pt",
    accent: "Brazilian",
    gender: "Male",
    speed: "Standard",
  },
];

// Cartesia Sonic Voices (Together AI - cartesia/sonic-3)
// High quality, low latency, 100+ voices, multilingual
export const CARTESIA_VOICES = [
  // English - American Female
  {
    name: "Helpful Woman",
    id: "helpful woman",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Warm & helpful (default)",
  },
  {
    name: "Calm Lady",
    id: "calm lady",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Soothing",
  },
  {
    name: "Reading Lady",
    id: "reading lady",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Narrator style",
  },
  {
    name: "Professional Woman",
    id: "professional woman",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Business-like",
  },
  {
    name: "Sweet Lady",
    id: "sweet lady",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Warm & friendly",
  },
  {
    name: "Storyteller Lady",
    id: "storyteller lady",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Engaging narrator",
  },
  {
    name: "Teacher Lady",
    id: "teacher lady",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Clear & instructive",
  },
  {
    name: "Meditation Lady",
    id: "meditation lady",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Peaceful",
  },
  {
    name: "ASMRLady",
    id: "asmr lady",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Soft & whispery",
  },
  {
    name: "Commercial Lady",
    id: "commercial lady",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Marketing style",
  },
  {
    name: "Laidback Woman",
    id: "laidback woman",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Relaxed",
  },
  {
    name: "Reflective Woman",
    id: "reflective woman",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Thoughtful",
  },
  {
    name: "Customer Support Lady",
    id: "customer support lady",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Service-oriented",
  },
  {
    name: "Sarah",
    id: "sarah",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Natural",
  },
  {
    name: "Sarah Curious",
    id: "sarah curious",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Inquisitive",
  },
  {
    name: "Anna",
    id: "anna",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Clear",
  },
  {
    name: "California Girl",
    id: "california girl",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "West coast vibe",
  },
  {
    name: "Princess",
    id: "princess",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Regal",
  },
  {
    name: "Anime Girl",
    id: "anime girl",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Animated style",
  },
  {
    name: "Child",
    id: "child",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Neutral",
    speed: "Fast",
    description: "Youthful",
  },
  // English - American Male
  {
    name: "Friendly Sidekick",
    id: "friendly sidekick",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Warm companion (default male)",
  },
  {
    name: "Reading Man",
    id: "reading man",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Narrator style",
  },
  {
    name: "Newsman",
    id: "newsman",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Broadcast style",
  },
  {
    name: "Newslady",
    id: "newslady",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Broadcast style",
  },
  {
    name: "Customer Support Man",
    id: "customer support man",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Service-oriented",
  },
  {
    name: "Friendly Reading Man",
    id: "friendly reading man",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Warm narrator",
  },
  {
    name: "Commercial Man",
    id: "commercial man",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Marketing style",
  },
  {
    name: "Announcer Man",
    id: "announcer man",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Energetic",
  },
  {
    name: "Sportsman",
    id: "sportsman",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Athletic energy",
  },
  {
    name: "Salesman",
    id: "salesman",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Persuasive",
  },
  {
    name: "Yogaman",
    id: "yogaman",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Calm & centered",
  },
  {
    name: "Movieman",
    id: "movieman",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Dramatic",
  },
  {
    name: "Wizardman",
    id: "wizardman",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Mystical",
  },
  {
    name: "Wise Man",
    id: "wise man",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Sage-like",
  },
  {
    name: "Wise Guide Man",
    id: "wise guide man",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Mentor style",
  },
  {
    name: "Pleasant Man",
    id: "pleasant man",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Agreeable",
  },
  {
    name: "Barbershop Man",
    id: "barbershop man",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Conversational",
  },
  {
    name: "Tutorial Man",
    id: "tutorial man",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Instructional",
  },
  {
    name: "John",
    id: "john",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Natural",
  },
  {
    name: "Midwestern Man",
    id: "midwestern man",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Heartland accent",
  },
  {
    name: "Midwestern Woman",
    id: "midwestern woman",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Heartland accent",
  },
  {
    name: "Kentucky Man",
    id: "kentucky man",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Southern drawl",
  },
  {
    name: "Kentucky Woman",
    id: "kentucky woman",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Southern charm",
  },
  {
    name: "Southern Man",
    id: "southern man",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Southern hospitality",
  },
  {
    name: "Southern Woman",
    id: "southern woman",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Southern grace",
  },
  {
    name: "Alabama Male",
    id: "alabama male",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Deep South",
  },
  // English - New York
  {
    name: "New York Man",
    id: "new york man",
    provider: "cartesia",
    language: "en",
    accent: "New York",
    gender: "Male",
    speed: "Fast",
    description: "City style",
  },
  {
    name: "New York Woman",
    id: "new york woman",
    provider: "cartesia",
    language: "en",
    accent: "New York",
    gender: "Female",
    speed: "Fast",
    description: "City style",
  },
  // English - British
  {
    name: "British Reading Lady",
    id: "british reading lady",
    provider: "cartesia",
    language: "en",
    accent: "British",
    gender: "Female",
    speed: "Fast",
    description: "Narrator style",
  },
  {
    name: "British Narration Lady",
    id: "british narration lady",
    provider: "cartesia",
    language: "en",
    accent: "British",
    gender: "Female",
    speed: "Fast",
    description: "Formal narration",
  },
  {
    name: "British Lady",
    id: "british lady",
    provider: "cartesia",
    language: "en",
    accent: "British",
    gender: "Female",
    speed: "Fast",
    description: "Natural British",
  },
  {
    name: "British Customer Support Lady",
    id: "british customer support lady",
    provider: "cartesia",
    language: "en",
    accent: "British",
    gender: "Female",
    speed: "Fast",
    description: "Service-oriented",
  },
  {
    name: "Wise Lady",
    id: "wise lady",
    provider: "cartesia",
    language: "en",
    accent: "British",
    gender: "Female",
    speed: "Fast",
    description: "Sage-like",
  },
  {
    name: "Confident British Man",
    id: "confident british man",
    provider: "cartesia",
    language: "en",
    accent: "British",
    gender: "Male",
    speed: "Fast",
    description: "Assured",
  },
  {
    name: "Classy British Man",
    id: "classy british man",
    provider: "cartesia",
    language: "en",
    accent: "British",
    gender: "Male",
    speed: "Fast",
    description: "Sophisticated",
  },
  // English - Australian
  {
    name: "Australian Woman",
    id: "australian woman",
    provider: "cartesia",
    language: "en",
    accent: "Australian",
    gender: "Female",
    speed: "Fast",
    description: "Natural Aussie",
  },
  {
    name: "Australian Male",
    id: "australian male",
    provider: "cartesia",
    language: "en",
    accent: "Australian",
    gender: "Male",
    speed: "Fast",
    description: "Natural Aussie",
  },
  {
    name: "Australian Customer Support Man",
    id: "australian customer support man",
    provider: "cartesia",
    language: "en",
    accent: "Australian",
    gender: "Male",
    speed: "Fast",
    description: "Service-oriented",
  },
  {
    name: "Friendly Australian Man",
    id: "friendly australian man",
    provider: "cartesia",
    language: "en",
    accent: "Australian",
    gender: "Male",
    speed: "Fast",
    description: "Warm & casual",
  },
  {
    name: "Australian Narrator Lady",
    id: "australian narrator lady",
    provider: "cartesia",
    language: "en",
    accent: "Australian",
    gender: "Female",
    speed: "Fast",
    description: "Narrator style",
  },
  // English - Indian
  {
    name: "Indian Lady",
    id: "indian lady",
    provider: "cartesia",
    language: "en",
    accent: "Indian",
    gender: "Female",
    speed: "Fast",
    description: "Natural Indian English",
  },
  {
    name: "Indian Man",
    id: "indian man",
    provider: "cartesia",
    language: "en",
    accent: "Indian",
    gender: "Male",
    speed: "Fast",
    description: "Natural Indian English",
  },
  {
    name: "Indian Customer Support Lady",
    id: "indian customer support lady",
    provider: "cartesia",
    language: "en",
    accent: "Indian",
    gender: "Female",
    speed: "Fast",
    description: "Service-oriented",
  },
  {
    name: "Hinglish Speaking Lady",
    id: "hinglish speaking lady",
    provider: "cartesia",
    language: "hi",
    accent: "Indian",
    gender: "Female",
    speed: "Fast",
    description: "Hindi-English mix",
  },
  // German
  {
    name: "German Conversational Woman",
    id: "german conversational woman",
    provider: "cartesia",
    language: "de",
    accent: "German",
    gender: "Female",
    speed: "Fast",
    description: "Natural German",
  },
  {
    name: "German Reporter Woman",
    id: "german reporter woman",
    provider: "cartesia",
    language: "de",
    accent: "German",
    gender: "Female",
    speed: "Fast",
    description: "Broadcast style",
  },
  {
    name: "German Reporter Man",
    id: "german reporter man",
    provider: "cartesia",
    language: "de",
    accent: "German",
    gender: "Male",
    speed: "Fast",
    description: "Broadcast style",
  },
  {
    name: "German Storyteller Man",
    id: "german storyteller man",
    provider: "cartesia",
    language: "de",
    accent: "German",
    gender: "Male",
    speed: "Fast",
    description: "Narrator style",
  },
  {
    name: "German Conversation Man",
    id: "german conversation man",
    provider: "cartesia",
    language: "de",
    accent: "German",
    gender: "Male",
    speed: "Fast",
    description: "Natural German",
  },
  {
    name: "German Woman",
    id: "german woman",
    provider: "cartesia",
    language: "de",
    accent: "German",
    gender: "Female",
    speed: "Fast",
    description: "Natural",
  },
  {
    name: "Friendly German Man",
    id: "friendly german man",
    provider: "cartesia",
    language: "de",
    accent: "German",
    gender: "Male",
    speed: "Fast",
    description: "Warm & casual",
  },
  {
    name: "Nonfiction Man",
    id: "nonfiction man",
    provider: "cartesia",
    language: "en",
    accent: "German",
    gender: "Male",
    speed: "Fast",
    description: "Documentary style",
  },
  // French
  {
    name: "French Conversational Lady",
    id: "french conversational lady",
    provider: "cartesia",
    language: "fr",
    accent: "French",
    gender: "Female",
    speed: "Fast",
    description: "Natural French",
  },
  {
    name: "French Narrator Lady",
    id: "french narrator lady",
    provider: "cartesia",
    language: "fr",
    accent: "French",
    gender: "Female",
    speed: "Fast",
    description: "Narrator style",
  },
  {
    name: "French Narrator Man",
    id: "french narrator man",
    provider: "cartesia",
    language: "fr",
    accent: "French",
    gender: "Male",
    speed: "Fast",
    description: "Narrator style",
  },
  {
    name: "Calm French Woman",
    id: "calm french woman",
    provider: "cartesia",
    language: "fr",
    accent: "French",
    gender: "Female",
    speed: "Fast",
    description: "Soothing",
  },
  {
    name: "Helpful French Lady",
    id: "helpful french lady",
    provider: "cartesia",
    language: "fr",
    accent: "French",
    gender: "Female",
    speed: "Fast",
    description: "Warm & helpful",
  },
  {
    name: "Friendly French Man",
    id: "friendly french man",
    provider: "cartesia",
    language: "fr",
    accent: "French",
    gender: "Male",
    speed: "Fast",
    description: "Warm & casual",
  },
  {
    name: "Stern French Man",
    id: "stern french man",
    provider: "cartesia",
    language: "fr",
    accent: "French",
    gender: "Male",
    speed: "Fast",
    description: "Serious",
  },
  // Spanish
  {
    name: "Mexican Woman",
    id: "mexican woman",
    provider: "cartesia",
    language: "es",
    accent: "Mexican",
    gender: "Female",
    speed: "Fast",
    description: "Natural Mexican Spanish",
  },
  {
    name: "Mexican Man",
    id: "mexican man",
    provider: "cartesia",
    language: "es",
    accent: "Mexican",
    gender: "Male",
    speed: "Fast",
    description: "Natural Mexican Spanish",
  },
  {
    name: "Spanish Narrator Man",
    id: "spanish narrator man",
    provider: "cartesia",
    language: "es",
    accent: "Spanish",
    gender: "Male",
    speed: "Fast",
    description: "Narrator style",
  },
  {
    name: "Spanish Narrator Lady",
    id: "spanish narrator lady",
    provider: "cartesia",
    language: "es",
    accent: "Spanish",
    gender: "Female",
    speed: "Fast",
    description: "Narrator style",
  },
  {
    name: "Spanish-speaking Lady",
    id: "spanish-speaking lady",
    provider: "cartesia",
    language: "es",
    accent: "Spanish",
    gender: "Female",
    speed: "Fast",
    description: "Natural Spanish",
  },
  {
    name: "Spanish-speaking Man",
    id: "spanish-speaking man",
    provider: "cartesia",
    language: "es",
    accent: "Spanish",
    gender: "Male",
    speed: "Fast",
    description: "Natural Spanish",
  },
  {
    name: "Spanish-speaking Reporter Man",
    id: "spanish-speaking reporter man",
    provider: "cartesia",
    language: "es",
    accent: "Spanish",
    gender: "Male",
    speed: "Fast",
    description: "Broadcast style",
  },
  {
    name: "Spanish-speaking Storyteller Man",
    id: "spanish-speaking storyteller man",
    provider: "cartesia",
    language: "es",
    accent: "Spanish",
    gender: "Male",
    speed: "Fast",
    description: "Narrator style",
  },
  {
    name: "Young Spanish-speaking Woman",
    id: "young spanish-speaking woman",
    provider: "cartesia",
    language: "es",
    accent: "Spanish",
    gender: "Female",
    speed: "Fast",
    description: "Youthful",
  },
  // Portuguese (Brazilian)
  {
    name: "Brazilian Young Man",
    id: "brazilian young man",
    provider: "cartesia",
    language: "pt",
    accent: "Brazilian",
    gender: "Male",
    speed: "Fast",
    description: "Natural Brazilian Portuguese",
  },
  {
    name: "Pleasant Brazilian Lady",
    id: "pleasant brazilian lady",
    provider: "cartesia",
    language: "pt",
    accent: "Brazilian",
    gender: "Female",
    speed: "Fast",
    description: "Warm Brazilian",
  },
  {
    name: "Friendly Brazilian Man",
    id: "friendly brazilian man",
    provider: "cartesia",
    language: "pt",
    accent: "Brazilian",
    gender: "Male",
    speed: "Fast",
    description: "Warm & casual",
  },
  // Italian
  {
    name: "Italian Narrator Woman",
    id: "italian narrator woman",
    provider: "cartesia",
    language: "it",
    accent: "Italian",
    gender: "Female",
    speed: "Fast",
    description: "Narrator style",
  },
  {
    name: "Italian Calm Man",
    id: "italian calm man",
    provider: "cartesia",
    language: "it",
    accent: "Italian",
    gender: "Male",
    speed: "Fast",
    description: "Soothing",
  },
  {
    name: "Italian Narrator Man",
    id: "italian narrator man",
    provider: "cartesia",
    language: "it",
    accent: "Italian",
    gender: "Male",
    speed: "Fast",
    description: "Narrator style",
  },
  // Japanese
  {
    name: "Japanese Children Book",
    id: "japanese children book",
    provider: "cartesia",
    language: "ja",
    accent: "Japanese",
    gender: "Female",
    speed: "Fast",
    description: "Storytelling style",
  },
  {
    name: "Japanese Woman Conversational",
    id: "japanese woman conversational",
    provider: "cartesia",
    language: "ja",
    accent: "Japanese",
    gender: "Female",
    speed: "Fast",
    description: "Natural Japanese",
  },
  {
    name: "Japanese Male Conversational",
    id: "japanese male conversational",
    provider: "cartesia",
    language: "ja",
    accent: "Japanese",
    gender: "Male",
    speed: "Fast",
    description: "Natural Japanese",
  },
  {
    name: "Japanese Man Book",
    id: "japanese man book",
    provider: "cartesia",
    language: "ja",
    accent: "Japanese",
    gender: "Male",
    speed: "Fast",
    description: "Narrator style",
  },
  // Chinese (Mandarin)
  {
    name: "Chinese Female Conversational",
    id: "chinese female conversational",
    provider: "cartesia",
    language: "zh",
    accent: "Mandarin",
    gender: "Female",
    speed: "Fast",
    description: "Natural Mandarin",
  },
  {
    name: "Chinese Commercial Man",
    id: "chinese commercial man",
    provider: "cartesia",
    language: "zh",
    accent: "Mandarin",
    gender: "Male",
    speed: "Fast",
    description: "Marketing style",
  },
  {
    name: "Chinese Commercial Woman",
    id: "chinese commercial woman",
    provider: "cartesia",
    language: "zh",
    accent: "Mandarin",
    gender: "Female",
    speed: "Fast",
    description: "Marketing style",
  },
  {
    name: "Chinese Woman Narrator",
    id: "chinese woman narrator",
    provider: "cartesia",
    language: "zh",
    accent: "Mandarin",
    gender: "Female",
    speed: "Fast",
    description: "Narrator style",
  },
  {
    name: "Chinese Call Center Man",
    id: "chinese call center man",
    provider: "cartesia",
    language: "zh",
    accent: "Mandarin",
    gender: "Male",
    speed: "Fast",
    description: "Service-oriented",
  },
  // Korean
  {
    name: "Korean Narrator Woman",
    id: "korean narrator woman",
    provider: "cartesia",
    language: "ko",
    accent: "Korean",
    gender: "Female",
    speed: "Fast",
    description: "Narrator style",
  },
  {
    name: "Korean Narrator Man",
    id: "korean narrator man",
    provider: "cartesia",
    language: "ko",
    accent: "Korean",
    gender: "Male",
    speed: "Fast",
    description: "Narrator style",
  },
  {
    name: "Korean Calm Woman",
    id: "korean calm woman",
    provider: "cartesia",
    language: "ko",
    accent: "Korean",
    gender: "Female",
    speed: "Fast",
    description: "Soothing",
  },
  // Russian
  {
    name: "Russian Calm Lady",
    id: "russian calm lady",
    provider: "cartesia",
    language: "ru",
    accent: "Russian",
    gender: "Female",
    speed: "Fast",
    description: "Soothing",
  },
  {
    name: "Russian Narrator Man 1",
    id: "russian narrator man 1",
    provider: "cartesia",
    language: "ru",
    accent: "Russian",
    gender: "Male",
    speed: "Fast",
    description: "Narrator style",
  },
  {
    name: "Russian Narrator Man 2",
    id: "russian narrator man 2",
    provider: "cartesia",
    language: "ru",
    accent: "Russian",
    gender: "Male",
    speed: "Fast",
    description: "Narrator style",
  },
  {
    name: "Russian Narrator Woman",
    id: "russian narrator woman",
    provider: "cartesia",
    language: "ru",
    accent: "Russian",
    gender: "Female",
    speed: "Fast",
    description: "Narrator style",
  },
  // Hindi
  {
    name: "Hindi Reporter Man",
    id: "hindi reporter man",
    provider: "cartesia",
    language: "hi",
    accent: "Hindi",
    gender: "Male",
    speed: "Fast",
    description: "Broadcast style",
  },
  {
    name: "Hindi Narrator Woman",
    id: "hindi narrator woman",
    provider: "cartesia",
    language: "hi",
    accent: "Hindi",
    gender: "Female",
    speed: "Fast",
    description: "Narrator style",
  },
  {
    name: "Hindi Calm Man",
    id: "hindi calm man",
    provider: "cartesia",
    language: "hi",
    accent: "Hindi",
    gender: "Male",
    speed: "Fast",
    description: "Soothing",
  },
  {
    name: "Hindi Narrator Man",
    id: "hindi narrator man",
    provider: "cartesia",
    language: "hi",
    accent: "Hindi",
    gender: "Male",
    speed: "Fast",
    description: "Narrator style",
  },
  // Dutch
  {
    name: "Dutch Confident Man",
    id: "dutch confident man",
    provider: "cartesia",
    language: "nl",
    accent: "Dutch",
    gender: "Male",
    speed: "Fast",
    description: "Assured",
  },
  {
    name: "Dutch Man",
    id: "dutch man",
    provider: "cartesia",
    language: "nl",
    accent: "Dutch",
    gender: "Male",
    speed: "Fast",
    description: "Natural Dutch",
  },
  // Swedish
  {
    name: "Swedish Narrator Man",
    id: "swedish narrator man",
    provider: "cartesia",
    language: "sv",
    accent: "Swedish",
    gender: "Male",
    speed: "Fast",
    description: "Narrator style",
  },
  {
    name: "Swedish Calm Lady",
    id: "swedish calm lady",
    provider: "cartesia",
    language: "sv",
    accent: "Swedish",
    gender: "Female",
    speed: "Fast",
    description: "Soothing",
  },
  // Polish
  {
    name: "Polish Narrator Woman",
    id: "polish narrator woman",
    provider: "cartesia",
    language: "pl",
    accent: "Polish",
    gender: "Female",
    speed: "Fast",
    description: "Narrator style",
  },
  {
    name: "Polish Narrator Man",
    id: "polish narrator man",
    provider: "cartesia",
    language: "pl",
    accent: "Polish",
    gender: "Male",
    speed: "Fast",
    description: "Narrator style",
  },
  {
    name: "Polish Confident Man",
    id: "polish confident man",
    provider: "cartesia",
    language: "pl",
    accent: "Polish",
    gender: "Male",
    speed: "Fast",
    description: "Assured",
  },
  {
    name: "Polish Young Man",
    id: "polish young man",
    provider: "cartesia",
    language: "pl",
    accent: "Polish",
    gender: "Male",
    speed: "Fast",
    description: "Youthful",
  },
  // Turkish
  {
    name: "Turkish Narrator Man",
    id: "turkish narrator man",
    provider: "cartesia",
    language: "tr",
    accent: "Turkish",
    gender: "Male",
    speed: "Fast",
    description: "Narrator style",
  },
  {
    name: "Turkish Calm Man",
    id: "turkish calm man",
    provider: "cartesia",
    language: "tr",
    accent: "Turkish",
    gender: "Male",
    speed: "Fast",
    description: "Soothing",
  },
  // Special Characters
  {
    name: "Pilot Over Intercom",
    id: "pilot over intercom",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Aviation style",
  },
  {
    name: "Female Nurse",
    id: "female nurse",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Medical setting",
  },
  {
    name: "Doctor Mischief",
    id: "doctor mischief",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Playful villain",
  },
  {
    name: "Madame Mischief",
    id: "madame mischief",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Female",
    speed: "Fast",
    description: "Playful villain",
  },
  {
    name: "The Merchant",
    id: "the merchant",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Character voice",
  },
  {
    name: "1920's Radioman",
    id: "1920's radioman",
    provider: "cartesia",
    language: "en",
    accent: "American",
    gender: "Male",
    speed: "Fast",
    description: "Vintage broadcast",
  },
];

// All voices combined
export const ALL_VOICES = [
  ...ORPHEUS_FAST_VOICES,
  ...ORPHEUS_VOICES,
  ...KOKORO_VOICES,
  ...CARTESIA_VOICES,
];

// Voice Languages with associated language codes for each TTS model

// Orpheus Fast (Groq) - English only
export const ORPHEUS_FAST_LANGUAGES = [
  { name: "English", id: "en", languageCode: "en", accent: "English" },
];

// Orpheus (Together AI) - English only
export const ORPHEUS_LANGUAGES = [
  { name: "English", id: "en", languageCode: "en", accent: "English" },
];

// Kokoro (Together AI) - Multilingual
export const KOKORO_LANGUAGES = [
  { name: "English", id: "en", languageCode: "en", accent: "English" },
  { name: "Spanish", id: "es", languageCode: "es", accent: "Spanish" },
  { name: "French", id: "fr", languageCode: "fr", accent: "French" },
  { name: "German", id: "de", languageCode: "de", accent: "German" },
  { name: "Italian", id: "it", languageCode: "it", accent: "Italian" },
  {
    name: "Portuguese (Brazil)",
    id: "pt-BR",
    languageCode: "pt",
    accent: "Brazilian",
  },
  { name: "Japanese", id: "ja", languageCode: "ja", accent: "Japanese" },
  {
    name: "Chinese (Mandarin)",
    id: "zh",
    languageCode: "zh",
    accent: "Mandarin",
  },
  { name: "Hindi", id: "hi", languageCode: "hi", accent: "Hindi" },
];

// Cartesia Sonic (Together AI) - Multilingual with more languages
export const CARTESIA_LANGUAGES = [
  { name: "English", id: "en", languageCode: "en", accent: "English" },
  { name: "Spanish", id: "es", languageCode: "es", accent: "Spanish" },
  { name: "French", id: "fr", languageCode: "fr", accent: "French" },
  { name: "German", id: "de", languageCode: "de", accent: "German" },
  { name: "Italian", id: "it", languageCode: "it", accent: "Italian" },
  {
    name: "Portuguese (Brazil)",
    id: "pt",
    languageCode: "pt",
    accent: "Brazilian",
  },
  { name: "Japanese", id: "ja", languageCode: "ja", accent: "Japanese" },
  {
    name: "Chinese (Mandarin)",
    id: "zh",
    languageCode: "zh",
    accent: "Mandarin",
  },
  { name: "Korean", id: "ko", languageCode: "ko", accent: "Korean" },
  { name: "Hindi", id: "hi", languageCode: "hi", accent: "Hindi" },
  { name: "Russian", id: "ru", languageCode: "ru", accent: "Russian" },
  { name: "Dutch", id: "nl", languageCode: "nl", accent: "Dutch" },
  { name: "Swedish", id: "sv", languageCode: "sv", accent: "Swedish" },
  { name: "Polish", id: "pl", languageCode: "pl", accent: "Polish" },
  { name: "Turkish", id: "tr", languageCode: "tr", accent: "Turkish" },
];

// Legacy export for backward compatibility
export const VOICE_LANGUAGES = KOKORO_LANGUAGES;

// Helper function to get languages by TTS model
export const getLanguagesByModel = (ttsModel) => {
  switch (ttsModel) {
    case "orpheus-fast":
    case "groq-orpheus":
      return ORPHEUS_FAST_LANGUAGES;
    case "orpheus":
      return ORPHEUS_LANGUAGES;
    case "kokoro":
      return KOKORO_LANGUAGES;
    case "cartesia":
      return CARTESIA_LANGUAGES;
    default:
      return ORPHEUS_FAST_LANGUAGES;
  }
};

// Helper function to get voices filtered by language
export const getVoicesByLanguage = (languageId, ttsModel = null) => {
  const languages = ttsModel ? getLanguagesByModel(ttsModel) : VOICE_LANGUAGES;
  const language = languages.find((l) => l.id === languageId);
  if (!language) {
    // If no language match, return voices for the TTS model if specified
    if (ttsModel) {
      return getVoicesByModel(ttsModel);
    }
    return ALL_VOICES;
  }

  // Get the base voice list - filter by TTS model if specified
  let voiceList = ttsModel ? getVoicesByModel(ttsModel) : ALL_VOICES;

  return voiceList
    .filter(
      (voice) =>
        voice.language === language.languageCode &&
        (language.accent === voice.accent ||
          // For English, also include American voices for US, British for UK, etc.
          (language.languageCode === "en" &&
            (language.accent === voice.accent ||
              // Include all English voices but prioritize matching accent
              voice.language === "en"))),
    )
    .sort((a, b) => {
      // Sort by accent match first (exact match comes first)
      const aMatch = a.accent === language.accent ? 0 : 1;
      const bMatch = b.accent === language.accent ? 0 : 1;
      if (aMatch !== bMatch) return aMatch - bMatch;
      // Then by speed (Fast first)
      if (a.speed === "Fast" && b.speed !== "Fast") return -1;
      if (b.speed === "Fast" && a.speed !== "Fast") return 1;
      // Then by name
      return a.name.localeCompare(b.name);
    });
};

// Helper function to format voice display name with accent and speed
export const formatVoiceDisplayName = (voice) => {
  const parts = [voice.name];
  if (voice.gender) parts.push(`(${voice.gender})`);
  if (voice.accent) parts.push(`- ${voice.accent}`);
  if (voice.speed === "Fast") parts.push("⚡");
  return parts.join(" ");
};

// STT Models (Speech-to-Text)
export const STT_MODELS = [
  { name: "Whisper Large V3", id: "whisper-large-v3", provider: "groq" },
  {
    name: "Whisper Large V3 Turbo (Fast)",
    id: "whisper-large-v3-turbo",
    provider: "groq",
  },
];

// LLM Voice Models (for voice processing)
export const LLM_VOICE_MODELS = [
  { name: "TF Sorcerer", id: "sorcerer" },
  { name: "TF Mystica", id: "mystica" },
  { name: "Qwen 3.6 27B", id: "qwen/qwen3.6-27b" },
  { name: "Kimi K2.6 Fast", id: "kimi-k2p6_fast" },
  { name: "GPT OSS 120B", id: "openai/gpt-oss-120b" },
];

// TTS Models (Text-to-Speech)
export const TTS_MODELS = [
  { name: "ToothFairyAI", id: "orpheus-fast", provider: "groq" },
  { name: "Orpheus", id: "orpheus", provider: "together" },
  { name: "Kokoro", id: "kokoro", provider: "together" },
  { name: "Cartesia Sonic", id: "cartesia", provider: "together" },
];

// Voice providers accepted by the Media audio_generation API (tts_model keys).
// "orpheus-fast" is LiveKit-voice-only and not valid for audio generation.
export const AUDIO_GENERATION_TTS_MODELS = TTS_MODELS.filter(
  (m) => m.id !== "orpheus-fast",
);

// Helper function to get voices by TTS model
export const getVoicesByModel = (ttsModel) => {
  switch (ttsModel) {
    case "orpheus-fast":
    case "groq-orpheus":
      return ORPHEUS_FAST_VOICES;
    case "orpheus":
      return ORPHEUS_VOICES;
    case "kokoro":
      return KOKORO_VOICES;
    case "cartesia":
      return CARTESIA_VOICES;
    default:
      return ORPHEUS_FAST_VOICES;
  }
};

// =============================================================================
// SPEECH TAGS - SSML/Emotion tags for TTS models
// Use @ in the Voice Instructions field to insert these tags
// =============================================================================

// Cartesia Sonic Speech Tags
// Full SSML support: spelling, emotions, nonverbalisms, pacing, pauses
export const CARTESIA_SPEECH_TAGS = [
  // === SPELLING ===
  {
    id: "spell",
    name: "🔤 Spell Out",
    tag: "<spell>ABC-123</spell>",
    description:
      "Reads each character separately. Essential for confirmation numbers, codes, and phone numbers so users can write them down.",
    category: "Spelling",
    example:
      '"Your booking reference is <spell>XYZ-789</spell>" → Voice says: "X-Y-Z dash 7-8-9"',
  },
  // === EMOTIONS ===
  {
    id: "emotion-happy",
    name: "😊 Happy",
    tag: '<emotion value="happy" />',
    description:
      "Makes the voice sound cheerful and positive. Great for good news or positive outcomes.",
    category: "Emotion",
    example:
      '"<emotion value="happy" /> Your application was approved!" → Sounds genuinely pleased',
  },
  {
    id: "emotion-excited",
    name: "🎉 Excited",
    tag: '<emotion value="excited" />',
    description:
      "Adds enthusiasm and energy. Use for announcements, achievements, or surprises.",
    category: "Emotion",
    example:
      '"<emotion value="excited" /> You won the prize!" → Animated, enthusiastic delivery',
  },
  {
    id: "emotion-calm",
    name: "😌 Calm",
    tag: '<emotion value="calm" />',
    description:
      "Creates a soothing, peaceful tone. Ideal for reassurance, meditation, or detailed explanations.",
    category: "Emotion",
    example:
      '"<emotion value="calm" /> Take your time, there\'s no rush." → Gentle, reassuring voice',
  },
  {
    id: "emotion-sad",
    name: "😢 Sad",
    tag: '<emotion value="sad" />',
    description:
      "Expresses sympathy or disappointment. Use when delivering unfortunate news.",
    category: "Emotion",
    example:
      '"<emotion value="sad" /> I\'m sorry, but the item is out of stock." → Melancholic tone',
  },
  {
    id: "emotion-angry",
    name: "😠 Angry",
    tag: '<emotion value="angry" />',
    description:
      "Shows frustration or strong disapproval. Use sparingly for dramatic effect.",
    category: "Emotion",
    example:
      '"<emotion value="angry" /> This should never have happened!" → Frustrated tone',
  },
  {
    id: "emotion-scared",
    name: "😨 Scared",
    tag: '<emotion value="scared" />',
    description:
      "Creates a fearful, anxious tone. Useful for dramatic storytelling or warnings.",
    category: "Emotion",
    example:
      '"<emotion value="scared" /> I\'m not sure we should continue..." → Worried, hesitant',
  },
  {
    id: "emotion-curious",
    name: "🤔 Curious",
    tag: '<emotion value="curious" />',
    description:
      "Adds an inquisitive, wondering tone. Good for asking follow-up questions.",
    category: "Emotion",
    example:
      '"<emotion value="curious" /> What made you choose that option?" → Interested, engaged',
  },
  {
    id: "emotion-frustrated",
    name: "😤 Frustrated",
    tag: '<emotion value="frustrated" />',
    description:
      "Expresses annoyance while staying professional. Use when explaining repeated issues.",
    category: "Emotion",
    example:
      '"<emotion value="frustrated" /> We\'ve tried this three times now." → Exasperated',
  },
  // === NONVERBAL ===
  {
    id: "laughter",
    name: "😄 Laughter",
    tag: "[laughter]",
    description:
      "Inserts a natural laugh sound. Makes conversations feel more human. Use for genuine humor moments.",
    category: "Nonverbal",
    example:
      "\"That's a good one [laughter] I hadn't thought of that.\" → Natural laugh inserted",
  },
  // === PACING ===
  {
    id: "speed-slow",
    name: "🐢 Speak Slower",
    tag: '<speed ratio="0.8"/>',
    description:
      "Reduces speaking pace by 20%. Use for complex information, instructions, or when user needs time to process.",
    category: "Pacing",
    example:
      '"<speed ratio="0.8"/> Let me explain this step by step." → More deliberate, clearer delivery',
  },
  {
    id: "speed-fast",
    name: "🐇 Speak Faster",
    tag: '<speed ratio="1.2"/>',
    description:
      "Increases speaking pace by 20%. Use for quick updates or when information is simple.",
    category: "Pacing",
    example:
      '"<speed ratio="1.2"/> Just a quick heads up about tomorrow." → Brisk, efficient delivery',
  },
  {
    id: "volume-soft",
    name: "🔇 Quieter",
    tag: '<volume ratio="0.7"/>',
    description:
      "Lowers volume for intimate or confidential moments. Creates a whisper-like effect.",
    category: "Pacing",
    example:
      '"<volume ratio="0.7"/> This is just between us..." → Quiet, conspiratorial tone',
  },
  {
    id: "volume-loud",
    name: "🔊 Louder",
    tag: '<volume ratio="1.5"/>',
    description:
      "Increases volume for emphasis or to grab attention. Use for important announcements.",
    category: "Pacing",
    example:
      '"<volume ratio="1.5"/> Important announcement!" → Projecting, commanding voice',
  },
  // === PAUSES ===
  {
    id: "pause-short",
    name: "⏸️ Short Pause",
    tag: '<break time="300ms"/>',
    description:
      "Adds a brief half-second pause. Use for emphasis or to let information sink in.",
    category: "Pause",
    example:
      '"The answer is<break time="300ms"/>forty-two." → Brief pause before reveal',
  },
  {
    id: "pause-medium",
    name: "⏸️ Pause",
    tag: '<break time="500ms"/>',
    description:
      "Adds a noticeable pause (half second). Good for transitions between topics or dramatic effect.",
    category: "Pause",
    example:
      '"Let me check<break time="500ms"/>Yes, that\'s correct." → Pause while "checking"',
  },
  {
    id: "pause-long",
    name: "⏸️ Long Pause",
    tag: '<break time="1s"/>',
    description:
      "Adds a full second pause. Creates suspense or gives time for user to respond mentally.",
    category: "Pause",
    example:
      '"And the winner is<break time="1s"/>John!" → Dramatic suspense before reveal',
  },
];

// Orpheus Speech Tags (Both Groq Fast and Together AI)
// Emotion-aware tags for expressiveness - these sound very natural
export const ORPHEUS_SPEECH_TAGS = [
  {
    id: "laugh",
    name: "😄 Laugh",
    tag: "<laugh>",
    description:
      "Adds a genuine laughter sound. Makes the conversation feel natural and human. Use for funny moments.",
    category: "Expressive",
    example:
      "\"That's hilarious <laugh> I can't believe that happened!\" → Natural laugh inserted mid-sentence",
  },
  {
    id: "chuckle",
    name: "😊 Chuckle",
    tag: "<chuckle>",
    description:
      "A softer, quieter laugh. Good for mild amusement or self-deprecating moments. More subtle than <laugh>.",
    category: "Expressive",
    example:
      '"Oh, I see what you did there <chuckle>" → Soft, appreciative laugh',
  },
  {
    id: "sigh",
    name: "😮‍💨 Sigh",
    tag: "<sigh>",
    description:
      "Adds a deep breath sound. Expresses relief, contemplation, or weariness. Very human touch.",
    category: "Expressive",
    example:
      '"<sigh> Finally, we\'re done with that project." → Relieved exhale',
  },
  {
    id: "gasp",
    name: "😲 Gasp",
    tag: "<gasp>",
    description:
      "A sharp intake of breath. Shows surprise or shock. Perfect for unexpected news.",
    category: "Expressive",
    example:
      '"<gasp> I didn\'t expect that result!" → Surprised gasp before speaking',
  },
  {
    id: "groan",
    name: "😤 Groan",
    tag: "<groan>",
    description:
      "A low moan expressing effort, frustration, or reluctance. Adds realism to difficult situations.",
    category: "Expressive",
    example:
      '"<groan> That\'s going to take forever to fix." → Frustrated groan',
  },
  {
    id: "yawn",
    name: "🥱 Yawn",
    tag: "<yawn>",
    description:
      "Tired, sleepy sound. Use sparingly for late-night scenarios or to show tiredness authentically.",
    category: "Expressive",
    example: '"<yawn> Sorry, it\'s been a long day." → Sleepy yawn',
  },
  {
    id: "cough",
    name: "😷 Cough",
    tag: "<cough>",
    description:
      "Clearing throat sound. Can add realism or be used as a natural transition/pause.",
    category: "Expressive",
    example:
      '"<cough> Excuse me, let me continue." → Throat clear before continuing',
  },
  {
    id: "sniffle",
    name: "🤧 Sniffle",
    tag: "<sniffle>",
    description:
      "Light nasal sound. Expresses emotional moments or physical discomfort. Use for sad/touching scenes.",
    category: "Expressive",
    example: '"<sniffle> That\'s such a touching story." → Emotional sniffle',
  },
];

// Kokoro Speech Tags
// No emotive tags - only precise pronunciation control using phonemes
export const KOKORO_SPEECH_TAGS = [
  {
    id: "phoneme-basic",
    name: "🔤 Correct Pronunciation",
    tag: "[word](/phonemes/)",
    description:
      "Force a specific pronunciation for names, brands, or unusual words. Prevents mispronunciation of important terms.",
    category: "Pronunciation",
    example:
      '"My name is [Siobhan](/ʃəvˈɔːn/)" → Correctly says "shi-vawn" instead of "see-o-ban"',
  },
  {
    id: "phoneme-stress",
    name: "🔤 Stress Syllable",
    tag: "' (before syllable)",
    description:
      "Place ˈ before the stressed syllable to change emphasis. Useful for differentiating words like REcord vs reCORD.",
    category: "Pronunciation",
    example:
      '"[record](/ˈrɛkərd/) the data" (noun) vs "[record](/rɪˈkɔrd/)" (verb) → Different emphasis',
  },
  {
    id: "phoneme-schwa",
    name: "⏸️ ə Schwa Sound",
    tag: "ə",
    description:
      "The most common vowel in English - an unstressed 'uh' sound. Essential for natural-sounding pronunciation.",
    category: "Pronunciation",
    example: '"[about](/əˈbaʊt/)" → The first sound is a schwa, not "ah-bout"',
  },
];

// Get speech tags for a TTS model
export const getSpeechTagsByModel = (ttsModel) => {
  switch (ttsModel) {
    case "orpheus-fast":
    case "groq-orpheus":
    case "orpheus":
      return ORPHEUS_SPEECH_TAGS;
    case "kokoro":
      return KOKORO_SPEECH_TAGS;
    case "cartesia":
      return CARTESIA_SPEECH_TAGS;
    default:
      return ORPHEUS_SPEECH_TAGS;
  }
};

// Get speech tags formatted for mentions dropdown
export const getSpeechTagsMentions = (ttsModel) => {
  const tags = getSpeechTagsByModel(ttsModel);
  return tags.map((tag) => ({
    id: tag.tag,
    name: tag.name,
    label: tag.name,
    description: tag.description,
    category: tag.category,
    example: tag.example,
  }));
};

// Get available tag categories for a TTS model
export const getSpeechTagCategories = (ttsModel) => {
  const tags = getSpeechTagsByModel(ttsModel);
  const categories = [...new Set(tags.map((tag) => tag.category))];
  return categories;
};
